import { useState, useEffect } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { bindActionCreators } from "redux";

import Statistics from "./statistics";
import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ApplicatedQuestionList from "../../../../components/ApplicatedQuestionList/ApplicatedQuestionList";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

const EvaluationADRList = props => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedActivityId, setSelectedActivityId] = useState(null);
  const [selectedActivityPDF, setSelectedActivityPDF] = useState(null);
  const [statisticsModal, setStatisticsModal] = useState(false);
  const [uploadPDFModal, setUploadPDFModal] = useState(false);
  const [finishConfirmationModal, setFinishConfirmationModal] = useState(false);
  const [finishLoading, setFinishLoading] = useState(false);
  const [attempts, setAttempts] = useState(1);
  const [durationMinutes, setDurationMinutes] = useState(60);
  const [noTimeLimit, setNoTimeLimit] = useState(false);
  const [scheduleStart, setScheduleStart] = useState("");
  const [scheduleEnd, setScheduleEnd] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [viewedActivity, setViewedActivity] = useState(null);

  const rowData = list.find(item => item.id === selectedActivityId);

  useEffect(() => {
    props.setObj(16, props.currentRoute, props.currentRoute);
    const obj = {
      user_id: props.user.user.id,
      ability_id: 0,
      difficulty_level_id: 0,
      year: 0,
      live: false,
      type_id: 6
    };

    (async () => {
      try {
        const listResponse = await axios.post(
          `${URL.api}activity/activity/list`,
          obj,
          {
            headers: { authorization: `Bearer ${props.user.token}` }
          }
        );

        const parsedData = listResponse.data.data;
        setList(parsedData);
      } catch (error) {
        toastr.error("Erro", "Erro ao carregar lista.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const insertAction = () => {
    props.history.push("/evaluation/adr/create");
  };

  const getSelected = selecteds => {
    // this.setState({
    // selectedQuestions: selecteds
    // });
  };

  const uploadAction = row => {
    setSelectedActivityId(row.id);
    setUploadPDFModal(true);
  };

  const viewAction = async row => {
    axios
      .get(`${URL.api}activity/activity/singleView/${row.id}`, {
        headers: { authorization: `Bearer ${props.user.token}` }
      })
      .then(activityResponse => {
        setViewModal(true);
        setSelectedActivityId(row.id);
        setViewedActivity(activityResponse.data.data);
      });
  };

  const deleteAction = arrayRow => {
    for (const row of arrayRow) {
      axios.post(
        `${URL.api}activity/activity/delete`,
        { id: row },
        {
          headers: { authorization: `Bearer ${props.user.token}` }
        }
      );
    }
  };

  const editAction = row => {
    props.history.push(`/evaluation/adr/create/${row.id}`);
  };

  const acceptAction = row => {
    setSelectedActivityId(row.id);
    setFinishConfirmationModal(true);
  };

  const closeFinishModal = () => {
    setFinishConfirmationModal(false);
    setAttempts(1);
    setDurationMinutes(60);
    setNoTimeLimit(false);
    setScheduleStart("");
    setScheduleEnd("");
  };

  const changeEvaluationStatusToFinished = async id => {
    if (!rowData?.file) {
      toastr.error(
        "Erro",
        "É necessário enviar um PDF da prova antes de finalizar."
      );
      return;
    }

    const groupId = props.general.active_roles.group_id;

    if (!groupId) {
      toastr.error("Erro", "ID do grupo/turma não encontrado.");
      return;
    }

    try {
      setFinishLoading(true);
      const evaluationResponse = await axios.post(
        URL.examMigrationAvaAdr,
        {
          activityId: id,
          groupId,
          attempts,
          duration_in_seconds: durationMinutes * 60,
          schedule_window_start: scheduleStart
            ? new Date(scheduleStart).toISOString()
            : undefined,
          schedule_window_end: scheduleEnd
            ? new Date(scheduleEnd).toISOString()
            : undefined
        },
        {
          headers: { authorization: `Bearer ${props.user.token}` }
        }
      );

      const newRow = evaluationResponse.data.data.activity;
      const newList = list.map(item => {
        if (item.id === id) return newRow;
        return item;
      });

      setList(newList);
      toastr.success("Sucesso", "Avaliação finalizada com sucesso.");
    } catch (error) {
      toastr.error("Erro", "Erro ao finalizar a avaliação.");
    } finally {
      setFinishLoading(false);
    }
  };

  const uploadPDF = async () => {
    const formData = new FormData();
    formData.append("file0", selectedActivityPDF);

    try {
      const uploadResponse = await axios.post(
        `${URL.api}file/evaluation/${props.user.user.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${props.user.token}`
          }
        }
      );

      const { name, url } = uploadResponse.data.files[0];

      const obj = {
        activity_id: selectedActivityId,
        name,
        link: URL.public + url
      };

      const pdfUpdateResponse = await axios.post(
        `${URL.api}activity/activity/insertFile`,
        obj,
        {
          headers: {
            Authorization: `Bearer ${props.user.token}`
          }
        }
      );

      const newList = list.map(item => {
        if (item.id === selectedActivityId) {
          return { ...item, file: pdfUpdateResponse.data.data };
        }
        return item;
      });

      setList(newList);
      toastr.success("Sucesso", "Prova enviada com sucesso.");
      setUploadPDFModal(false);
    } catch (error) {
      toastr.error("Erro", "Erro ao enviar a prova.");
    }
  };

  const deleteUploadedPDF = async () => {
    try {
      await axios.post(
        `${URL.api}removeFile/evaluation/${props.user.user.id}`,
        { name: rowData.file.name },
        {
          headers: {
            Authorization: `Bearer ${props.user.token}`
          }
        }
      );

      await axios.post(
        `${URL.api}activity/activity/deleteFile`,
        { activity_id: selectedActivityId },
        {
          headers: {
            Authorization: `Bearer ${props.user.token}`
          }
        }
      );

      const newList = list.map(item => {
        if (item.id === selectedActivityId) {
          return { ...item, file: null };
        }
        return item;
      });

      setList(newList);
      toastr.success("Sucesso", "PDF removido com sucesso.");
    } catch (error) {
      toastr.error("Erro", "Erro ao remover a prova.");
    }
  };

  return (
    <>
      <Modal
        isOpen={finishLoading}
        size="sm"
        centered
        backdrop="static"
        keyboard={false}
      >
        <ModalBody className="text-center py-4">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="sr-only">Carregando...</span>
          </div>
          <p className="mb-0 font-weight-bold">Por favor, aguarde...</p>
        </ModalBody>
      </Modal>
      <Breadcrumb current={props.currentRoute} />
      <Statistics
        show={statisticsModal}
        onClose={() => setStatisticsModal(false)}
        activity_id={selectedActivityId}
        currentRoute={props.currentRoute}
        title={list.find(item => item.id === selectedActivityId)?.nome}
      />
      <Modal
        isOpen={uploadPDFModal}
        size="md"
        toggle={() => setUploadPDFModal(!uploadPDFModal)}
      >
        <form
          onSubmit={e => {
            e.preventDefault();
            uploadPDF();
          }}
        >
          <ModalHeader toggle={() => setUploadPDFModal(!uploadPDFModal)}>
            Upload de Prova
          </ModalHeader>
          <ModalBody>
            {rowData?.file ? (
              <button
                className="d-flex border rounded p-0 w-100"
                type="button"
                onClick={() => window.open(rowData.file.link, "_blank")}
              >
                <div className="bg-warning p-3 h-100 rounded-left">
                  <i className="fa fa-file"></i>
                </div>
                <div className="d-flex align-items-center justify-content-start my-3 mx-2">
                  {rowData.file.name}
                </div>
              </button>
            ) : (
              <div className="form-group">
                <label>Selecione o arquivo PDF</label>
                <input
                  className="form-control-file"
                  type="file"
                  accept=".pdf"
                  onChange={e => setSelectedActivityPDF(e.target.files[0])}
                />
              </div>
            )}
          </ModalBody>
          {rowData?.file ? (
            <ModalFooter>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => deleteUploadedPDF()}
              >
                <i className="fa fa-trash mr-1"></i>
                Remover PDF
              </button>
            </ModalFooter>
          ) : (
            <ModalFooter>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setUploadPDFModal(!uploadPDFModal)}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!selectedActivityPDF}
              >
                Enviar
              </button>
            </ModalFooter>
          )}
        </form>
      </Modal>

      <Modal
        isOpen={finishConfirmationModal}
        size="md"
        toggle={closeFinishModal}
      >
        <form
          onSubmit={e => {
            e.preventDefault();
            closeFinishModal();
            changeEvaluationStatusToFinished(selectedActivityId);
          }}
        >
          <ModalHeader toggle={closeFinishModal}>
            Finalizar Avaliação
          </ModalHeader>
          <ModalBody>
            <p className="mt-2">
              Tem certeza que deseja finalizar a avaliação{" "}
              <b>{rowData?.name}</b>?
            </p>
            <div className="form-group">
              <label htmlFor="finish-attempts">Tentativas</label>
              <input
                id="finish-attempts"
                type="number"
                className="form-control"
                min={1}
                value={attempts}
                onChange={e => setAttempts(Number(e.target.value))}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="finish-duration">Duração (minutos)</label>
              {!noTimeLimit ? (
                <input
                  id="finish-duration"
                  type="number"
                  className="form-control"
                  min={1}
                  value={durationMinutes}
                  onChange={e => setDurationMinutes(Number(e.target.value))}
                  required
                />
              ) : (
                <p className="form-control-plaintext">Sem limite</p>
              )}
              <div className="form-check mt-2">
                <input
                  id="no-time-limit"
                  type="checkbox"
                  className="form-check-input"
                  checked={noTimeLimit}
                  onChange={e => {
                    const checked = e.target.checked;
                    setNoTimeLimit(checked);
                    if (checked) {
                      setDurationMinutes(0);
                    } else {
                      setDurationMinutes(60);
                    }
                  }}
                />
                <label htmlFor="no-time-limit" className="form-check-label">
                  Sem limite de duração
                </label>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="finish-start">Início do Agendamento</label>
              <input
                id="finish-start"
                type="datetime-local"
                className="form-control"
                value={scheduleStart}
                onChange={e => setScheduleStart(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="finish-end">Fim do Agendamento</label>
              <input
                id="finish-end"
                type="datetime-local"
                className="form-control"
                value={scheduleEnd}
                onChange={e => setScheduleEnd(e.target.value)}
                required
              />
            </div>
            <p className="text-danger">
              Essa operação é definitiva! <br />
            </p>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeFinishModal}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Finalizar
            </button>
          </ModalFooter>
        </form>
      </Modal>

      <Modal
        isOpen={viewModal}
        toggle={() => setViewModal(!viewModal)}
        size="xl"
      >
        <ModalHeader toggle={() => setViewModal(!viewModal)}>
          Visualizar
        </ModalHeader>
        <ModalBody>
          {!viewedActivity ? (
            <Loading top="45" left="50" />
          ) : (
            <ApplicatedQuestionList
              activityId={selectedActivityId}
              currentRoute={props.currentRoute}
              id={viewedActivity.items[0].obj_id}
              history={props.history}
              prototype
              item_id={viewedActivity.item_id}
              result_type={viewedActivity.result_type}
              ended={false}
              end_date={viewedActivity.activity_end}
              viewModal
            />
          )}
        </ModalBody>
        {viewedActivity?.status_id === 1 && (
          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary d-flex align-items-center justify-content-center"
              onClick={() => {
                setViewModal(false);
                setUploadPDFModal(true);
              }}
            >
              {rowData?.file ? (
                <>
                  <i className="fa fa-eye mr-2"></i>
                  <p className="m-0">Visualizar PDF da prova</p>
                </>
              ) : (
                <>
                  <i className="fa fa-upload mr-2"></i>
                  <p className="m-0">Fazer upload da prova</p>
                </>
              )}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                setViewModal(false);
                setFinishConfirmationModal(true);
              }}
            >
              Finalizar Avaliação
            </button>
          </ModalFooter>
        )}
      </Modal>

      <div className="animated fadeIn">
        {loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            <div id="list" className="col-12">
              <DataTable
                list={list || []}
                path="/evaluation/create/"
                title="Avaliações ADR"
                header={[
                  { name: "id", denomination: "ID" },
                  { name: "adr_name", denomination: "ADR", width: 108 },
                  { name: "name", denomination: "Nome" },
                  { name: "discipline_name", denomination: "Disciplina" },
                  { name: "serie_name", denomination: "Série", width: 108 },
                  { name: "status_name", denomination: "Status", width: 180 }
                ]}
                insert
                insertAction={insertAction}
                getSelected={getSelected}
                action
                btnEdit
                editAction={editAction}
                btnView
                viewAction={viewAction}
                btnAccept
                acceptAction={acceptAction}
                btnUpload
                uploadAction={uploadAction}
                deleteAction={deleteAction}
              />
            </div>
          </Row>
        )}
      </div>
      <ProtectedRoute routeId={props.currentRoute} />
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout, setObj }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationADRList);
